'use strict';

const _=require('pulsar-utils/dist-es6/_');
const Guid=require('pulsar-utils/dist-es6/domain/guid');let

TableColumn=class TableColumn{
constructor(label='',orderByDefinition=[],defaultAscending=!0,finalSort=[],isInitiallyActive=!1,columnClass=''){
this._label=label;
this._isAscendingByDefault=defaultAscending;
this._ascending=defaultAscending;
this._sortDisabled=!_.exists(orderByDefinition)||orderByDefinition.length===0;

this._setOrderArrays(orderByDefinition,finalSort);

if(isInitiallyActive){
this.sort();
}

this._columnClass=columnClass;
}

_setOrderArrays(orderByDefinition,finalSort){
if(this._sortDisabled){
this._sortOrders={
ascending:[],
descending:[]};

}else if(_.isArray(orderByDefinition)){
this._sortOrders={
ascending:orderByDefinition.concat(finalSort),
descending:this._reverseSortOrder(orderByDefinition).concat(finalSort)};

}else if(_.isObject(orderByDefinition)){
if(!_.hasAllKeys(orderByDefinition,['ascending','descending'])){
throw new Error('Column "orderBy" object definition must have both "ascending" and "descending" keys.');
}

this._sortOrders={
ascending:orderByDefinition.ascending.concat(finalSort),
descending:orderByDefinition.descending.concat(finalSort)};

}else{
throw new Error('Column "orderBy" object definition must be an array, or an object.');
}
}

_invert(value){
if(_.isFunction(value)){
return v=>this._invert(value(v));
}

if(_.isBoolean(value)){
return!value;
}

if(_.isNumber(value)){
return-1*value;
}

if(_.isString(value)){
return value[0]==='-'?value.replace(/^-/,''):`-${value}`;
}

throw new Error(`Not sure how to invert this value: ${value}`);
}

_reverseSortOrder(sortOrder){
return sortOrder.map(sortValue=>this._invert(sortValue));
}

sort(){
if(this._isActive){
this._ascending=!this._ascending;
}

this._isActive=!0;
this._orderBy=this._ascending?this._sortOrders.ascending:this._sortOrders.descending;
}

endSort(){
this._isActive=!1;
this._ascending=this._isAscendingByDefault;
}

get label(){
return this._label;
}

get ascending(){
return this._ascending;
}

get isActive(){
return this._isActive;
}

get orderBy(){
return this._orderBy;
}

get sortDisabled(){
return this._sortDisabled;
}

get columnClass(){
return this._columnClass;
}

static fromColumnDefinition(columnDef){
const{label,defaultAscending,orderBy,finalSort,isInitiallyActive,columnClass}=columnDef;

return new TableColumn(label,orderBy,defaultAscending,finalSort,isInitiallyActive,columnClass);
}};


module.exports=TableColumn;
//# sourceMappingURL=tableColumn.js.map
